import {Component, Injector, OnInit} from '@angular/core';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from "@angular/material/bottom-sheet";
import {PopupDispatcher} from '@app/presentation/components/errors/popup.dispatcher';
import {DeleteListViewModel} from "@app/presentation/pages/delete-list/delete-list.view-model";
import {TranslateService} from '@ngx-translate/core';
import {ExitService} from "@app/presentation/services/exit.service";
import {SIDE_SHEET_DATA} from "@app/presentation/services/side-sheet/side-sheet.service";
import {ToastService} from "@app/presentation/services/toast/toast.service";

@Component({
  selector: 'app-delete-list',
  templateUrl: './delete-list.component.html',
  styleUrls: ['./delete-list.component.scss']
})
export class DeleteListComponent implements OnInit {

  private listId?: number;

  private bottomSheetRef?: MatBottomSheetRef

  isDeleteListLoading$ = this.deleteListViewModel.isDeleteListLoading$;

  constructor(
    private deleteListViewModel: DeleteListViewModel,
    private popupDispatcher: PopupDispatcher,
    private translateService: TranslateService,
    private injector: Injector,
    private toastService: ToastService,
  ) {
    this.popupDispatcher.setNotifier(deleteListViewModel.notifier);
    this.deleteListViewModel.deleteListSucceed$.subscribe({
      next: () => {
        this.toastService.show(this.translateService.instant("action_message.lists.successfully_deleted"));
        this.returnToThePreviousPageOrCloseBottomSheet();
      }});
  }

  ngOnInit(): void {
    try {
      const bottomSheetData = this.injector.get(MAT_BOTTOM_SHEET_DATA)
      this.listId = bottomSheetData?.listId;

      this.bottomSheetRef = this.injector.get(MatBottomSheetRef);
    } catch { }

    try {
      const sideSheetData = this.injector.get(SIDE_SHEET_DATA)
      this.listId = sideSheetData?.listId;
    } catch { }

  }

  deleteList() {
    if (this.listId) {
      this.deleteListViewModel.deleteList(this.listId);
    }
  }

  returnToThePreviousPageOrCloseBottomSheet() {
    if (this.bottomSheetRef) {
      this.bottomSheetRef.dismiss();
      return
    }
    ExitService.exit(this.injector);
  }



}
